import {createPortError} from '../platform/port-error.js';
import {woodFromRow} from './wood-catalogue.js';

function requireClient(client){
  if(typeof client?.from!=='function')throw new TypeError('Database client with from() is required');
  return client;
}

export function createSupabaseWoodCatalogueRemote({client}={}){
  const db=requireClient(client);
  async function list(){
    const {data,error}=await db
      .from('wood_catalogue')
      .select('key,species_name,display_name_pl,display_name_en,catalogue_version,sort_order,is_active,metadata')
      .eq('is_active',true)
      .order('sort_order',{ascending:true});
    if(error)throw createPortError('CATALOGUE_REMOTE_UNAVAILABLE',{retryable:true});
    return Object.freeze((data||[])
      .filter(row=>row?.is_active!==false)
      .map(row=>woodFromRow(row,{locale:'pl'})));
  }
  return Object.freeze({list});
}
